import React from "react";

export class Home extends React.Component
{
    render()
    {
        return (
            <div className="home">
                <h1>Alexa for Panopto</h1>
                <p>Welcome to Alexa for Panopto. You can now use your Alexa device to start, extend, or stop a Panopto Remote Recorder device.</p>
                <h2>Setting Up</h2>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <h2>Dashboard</h2>
                <h3>System Configuration</h3>
                <ul>
                    <li>FMP Service URL: {process.env.REACT_APP_FMP_SERVICE_URL}</li>
                    <li>Alexa Service URL: {process.env.REACT_APP_ALEXA_SERVICE_URL}</li>
                </ul>
                <h3>Connected Alexa Devices</h3>
                <h3>Alexa-enabled Remote Recorders</h3>
                <h3>Alexa-enabled Folders</h3>
            </div>
        )
    }
}